import * as evts from './event-types'

const oneMinute = 1000 * 60
const fifteenMinutes = oneMinute * 15

class Stats {
  init(auth, user, firestore) {
    this.auth = auth
    this.user = user
    this.firestore = firestore
    window.addEventListener('unload', () => this.endSession())
  }

  setOptInStats(optInStats) {
    this.optInStats = optInStats
  }

  startSession() {
    if (this.sessionHasStarted) {
      this.endSession()
    }

    this.sessionHasStarted = true
    this.lastEvent = new Date().getTime()

    this.addEvent(evts.SESSION_START)

    this.sessionTimeoutCheck = setInterval(() => {
      const now = new Date().getTime()
      const diff = now - this.lastEvent
      if (diff >= fifteenMinutes) {
        this.endSession()
      }
    }, oneMinute)
  }

  addEvent(eventType) {
    if (!this.user.optInStats) {
      return
    }

    const now = new Date().getTime()
    this.lastEvent = now
    const event = {
      user: this.auth.uid,
      timestamp: now,
      type: eventType,
      project: '', // TODO - Add active project reference here
      session: '', // TODO - Add active session reference here
    }
    this.firestore
      .collection('stats')
      .add(event)
      .then(() => console.log(eventType + ' event created'))
      .catch(e => console.error('Could not create ' + eventType + ' event', e))
  }

  endSession() {
    if (this.sessionHasStarted) {
      clearInterval(this.sessionTimeoutCheck)
      this.addEvent(evts.SESSION_END)
      this.sessionHasStarted = false
    }
  }
}

export default new Stats()
